export enum ActionCode {
    Add = 'A',
    Modify = 'M',
    Delete = 'D',
}
